import { axCoerceString } from '../run/axCoerceString';
import { Errors } from '../errors';
export function Toplevel_registerClassAlias(sec, aliasName, classObject) {
    aliasName = axCoerceString(aliasName);
    if (!aliasName) {
        sec.throwError('TypeError', Errors.NullPointerError, 'aliasName');
    }
    if (!classObject) {
        sec.throwError('TypeError', Errors.NullPointerError, 'classObject');
    }
    sec.classAliases.registerClassAlias(aliasName, classObject);
}
